import styled from 'styled-components';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Button } from 'takeat-design-system-ui-kit';

export const ContainerPaymentAdvance = styled.div`
  display: block;
  padding: 12px 8px 12px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 11px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--Takeat-Colors-Neutrals-White-02, #f6f6f6);
`;

export const ContentPaymentAdvance = styled.div`
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  transition: all 0.1s ease;
`;

export const HeaderPaymentAdvance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const TextPaymentAdd = styled.span`
  color: #666;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const MethodsPaymentAdvance = styled(Button)`
  position: relative;
  z-index: 1;
  border: 1px solid
    ${(props) =>
      props.isSelected
        ? '#c8131b'
        : 'var(--Takeat-Colors-Neutrals-Grey-04, #fff)'};
  background: var(--Takeat-Colors-Neutrals-White, #fff);
  width: 100%;
  min-width: 0;

  &:hover {
    border-color: #c8131b !important;
    background: var(--Takeat-Colors-Neutrals-White, #fff);
  }
`;

export const CheckIcon = styled.div`
  position: absolute;
  top: -10px;
  right: -10px; /* alinha pelo lado direito */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  svg {
    fill: #c8131b;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    width: 53%;
    background: white;
    z-index: -1;
  }
`;

export const TextMethodAdvance = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  text-align: center;

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
`;

export const PaymentsAdvance = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* sempre 3 colunas iguais */
  gap: 16px;

  & > * {
    width: 100%;
  }
`;

export const CustomToggle = styled(DropdownToggle)`
  display: flex;
  width: 100%;
  height: 40px !important;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 8px !important;
  border: 1px solid
    ${(props) =>
      props.isSelected
        ? '#c8131b'
        : 'var(--Takeat-Colors-Neutrals-Grey-04, #fff)'};
  background: var(--Takeat-Colors-Neutrals-White, #fff) !important;
  cursor: pointer;

  &:hover {
    background: var(--Takeat-Colors-Neutrals-White, #fff) !important;
    border-color: #c8131b !important;
  }
  .custom-toggle,
  .custom-toggle:active,
  .custom-toggle.active,
  .show > .custom-toggle.dropdown-toggle {
    background-color: var(--Takeat-Colors-Neutrals-White, #fff) !important;
    border-color: var(--Takeat-Colors-Neutrals-Grey-04, #ededed) !important;
    color: #000 !important;
    box-shadow: none !important;
  }

  body:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  &:focus {
    background-color: var(--Takeat-Colors-Neutrals-White, #fff) !important;
  }
`;

export const FixedDropdownMenu = styled(DropdownMenu)`
  position: absolute !important;
  top: 20px !important;
  left: auto !important;
  z-index: 9999 !important;
  inset: 0px 0px auto auto !important;
  transform: translate(1px, 48px) !important;
  overflow-x: auto !important;
  height: 150px !important;
`;

export const TextSummary = styled.span`
  color: #3d3d3d;
  font-family: Poppins;
  font-size: ${({ $total }) => ($total ? '18px' : '16px')};

  font-style: normal;
  font-weight: 700;
  line-height: 182%; /* 29.12px */
`;

export const TextMethodSummary = styled.span`
  color: #3d3d3d;

  /* Label/Label Large/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ $total }) => ($total ? '700' : '500')};
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;
